<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!-- * 内页banner * -->
		<div class="page-banner">
			<img :src="title=='人才招聘'?require('@/assets/images/banner09.png'):require('@/assets/images/banner10.png')"
				alt="内页banner">
			<div class="nybt">
				<h3>内页banner</h3>
			</div>
		</div>
		<!-- * 当前位置 * -->
		<div class="page-position">
			<div class="wh">
				当前位置：
				<a href="/">首页</a>
				&gt;
				{{title}}
			</div>
		</div>

		<!-- * 主体部分 * -->
		<div class="page-wrap">
			<div class="wh clearfix">


				<!-- * 右侧 * -->
				<div class="page-wrap-right">

					<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
						<div>
							<ul class="xypg-left-nav">
								<li :class="item.categoryCode==type?'clicked':''" v-for="item in actList">
									<a href="javascript:void(0)"
										@click="changeData(item.categoryCode,item.categoryName)">
										{{item.categoryName}}</a>
									<div class="first-nav-btn"></div>
								</li>
							</ul>
						</div>
					</div>
					<div class="xypg-right-content">
						<div  v-if="title=='人才招聘'">
						<div class="tab-box">
							<el-tabs v-model="activeName" @tab-click="handleClick">
								<el-tab-pane label="招聘列表" name="1"></el-tab-pane>
								<el-tab-pane label="推荐自荐" name="2"></el-tab-pane>
							</el-tabs>
						</div>
						<div v-if="activeName==1">
							<!-- 新闻列表页 -->
							<ul class="zhaopinlist">
								<li v-for="item in list"><a href="javascript:void(0)" @click="goDetail(item.id,item.postName)">
										<div class="zp-left"><img src="@/assets/images/right.png">
										</div>
										<div class="zp-mid">
											<div class="zp-tit">
												{{item.postName}}

											</div>
											<div class="zp-c">
												专业要求：{{item.major}} 学历要求：{{item.education}} 招聘人数：{{item.empNum}}人 工作地点：{{item.workAddress}}
											</div>
										</div>
										<div class="zp-right"><img src="@/assets/images/tou.png"></div>

									</a></li>

							</ul>
							<div class="xypg-pagination">
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
									layout="total, sizes, prev, pager, next, jumper" :total="total">
								</el-pagination>
							</div>
						</div>
						</div>
						<div class="contact" v-if="title=='联系我们'||activeName==2">
							<img :src="detail.image" v-if="detail.image">
							<div v-html="detail.cmsArticleData?detail.cmsArticleData.content:''"></div>
						</div>
					</div>


				</div>
			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';

	import {
		articleDetail,
		categorysortPage,
		articleList,
		hrpostList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pageNum: 1,
				pageCount: 0,
				actList: [],
				type: '',
				title: '',
				total: 0,
				list: [],
				pageNum: 1,
				pageSize: 10,
				activeName: '1',
			}
		},

		mounted() {

			this.type = this.$route.query.type
			this.title = this.$route.query.title
			this.getCategorysortPage()
			this.changeData(this.type, this.title)


		},

		methods: {
			goDetail(id, name) {
				this.$router.push({
					path: '/deliver',
					query: {
						id: id,
						name: name
					}
				});
			},


			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '联系我们') {
							this.actList = item.children
							this.actList.sort((a, b) => a.orderNum - b.orderNum);

						}
					})

				});
			},
			changeData(id, title) {
				this.type = id
				this.title = title

				if (this.title == '人才招聘') {
					this.activeName = '1'
					this.pageNum = 1
					this.getData()
				}
				this.getCaseList()


			},
			handleClick() {
				if (this.activeName == 2) {
					this.pageNum = 1
					this.getData()
				}

			},
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},

			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			getData() {
				hrpostList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				}).then(res => {
					this.list = res.rows
					this.total = res.total

				});
			},
			getCaseList() {
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: this.type,
				}).then(res => {
					if (res.rows.length > 0) {
						this.id = res.rows[0].id
						this.getNewDetail()
					}
				});
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
						let cmsArticleData = this.detail.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}


				});
			},



		}
	}
</script>

<style scoped>


.tab-box {
		margin: auto;
		width: fit-content;
	}

	.tab-box>>>.el-tabs__item.is-active {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__item:hover {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__active-bar {
		background-color: #0070b0 !important;
	}
</style>